export default __webpack_public_path__ + "static/media/pay-to-close.328e8144.png";